import { NativeModulesProxy } from 'expo-modules-core';

import { NotificationChannelGroupManager } from './NotificationChannelGroupManager.types';

export default NativeModulesProxy.ExpoNotificationChannelGroupManager as any as NotificationChannelGroupManager;
